

















import {Component, Vue, Prop} from 'vue-property-decorator';

@Component
export default class PracticeContent extends Vue {
  @Prop()
  subject!: string;

  get kanjiSubject(): string {
    switch (this.subject) {
      case 'jouyou':
        return '乗用';
      case 'kamotsu':
        return '貨物';
      default:
        return '';
    }
  }

  get contentNum(): number {
    switch (this.subject) {
      case 'jouyou':
        return 4001;
      case 'kamotsu':
        return 4002;
      default:
        return 0;
    }
  }

  get questionFile(): string {
    return '/pdf/practice_1/jaai_jitsugi_kogata_' + this.subject + '1_question_2026.pdf';
  }

  get answerFile(): string {
    return '/pdf/practice_1/jaai_jitsugi_kogata_' + this.subject + '1_answer_2026.pdf';
  }

  // method
  toContent(): void {
    this.$router.push({path: `/content/${this.contentNum}`}).catch(() => {
      // @ts-ignore block is empty.
    });
  }
}
